import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbAccordionModule, NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../services';
import { SharedModule } from '../shared';
import { CalendarEventsComponent } from './calendar-events';
import { DashboardCalendarComponent } from './dashboard-calendar';
import { DashboardEventsComponent } from './dashboard-events';
import { DashboardComponent } from './dashboard.component';



@NgModule({
	declarations: [
		DashboardComponent,
		DashboardCalendarComponent,
		CalendarEventsComponent,
		DashboardEventsComponent
	],
	imports: [
		CommonModule,
		NgbDatepickerModule,
		SharedModule,
		NgbTooltipModule,
		NgbAccordionModule
	],
	providers: [
		DashboardService
	]
})
export class DashboardModule { }
